import * as url from "../url.helper";

import { post } from "../api.helper";

export const addCamData = data => post(url.ADD_CAM_DATA, data);

export const getCamData = data => post(url.GET_CAM_DATA, data);

export const editCamData = data => post(url.EDIT_CAM_DATA, data);

export const approveCam = data => post(url.APPROVE_CAM, data);

export const downloadCam = data => post(url.DOWNLOAD_CAM, data);

